import React from "react";
import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  IRatingSetting,
  RatingSetting,
  ResponseOfRatingSetting,
} from "services/KnowfullyAdminClient";

import QuestionRatingForm from "./QuestionRatingForm";

type QuestionCreateFormProps = {
  onQuestionRatingCreated: (createdSetting: RatingSetting) => void;
  onCancel: () => void;
};

const QuestionRatingCreateForm = ({
  onQuestionRatingCreated,
  onCancel,
}: QuestionCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { questionService } = useGlobalContext();

  const onSubmit = (values: IRatingSetting) => {
    return registerPromise(
      questionService.saveRatingSetting(new RatingSetting(values))
    )
      .then(({ data: createdSetting }: ResponseOfRatingSetting) => {
        onQuestionRatingCreated(createdSetting!);
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <QuestionRatingForm
      onSubmit={onSubmit}
      submitLabel={t({ id: "questionRatingCreateButton" })}
      onCancel={onCancel}
    />
  );
};

export default QuestionRatingCreateForm;
